var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoonEnabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5297 15.9304C21.3697 15.6604 20.9197 15.2404 19.7997 15.4404C19.1797 15.5504 18.5497 15.6004 17.9197 15.5704C15.5897 15.4704 13.4797 14.4004 12.0097 12.7504C10.7097 11.3004 9.90971 9.41036 9.89971 7.37036C9.89971 6.23036 10.1197 5.13036 10.5697 4.09036C11.0097 3.08036 10.6997 2.55036 10.4797 2.33036C10.2497 2.10036 9.70971 1.78036 8.64971 2.22036C4.55971 3.94036 2.02971 8.04036 2.32971 12.4304C2.62971 16.5604 5.52971 20.0904 9.36971 21.4204C10.2897 21.7404 11.2597 21.9304 12.2597 21.9704C12.4197 21.9804 12.5797 21.9904 12.7397 21.9904C16.0897 21.9904 19.2297 20.4104 21.2097 17.7204C21.8797 16.7904 21.6997 16.2004 21.5297 15.9304Z",
    fill: "url(#paint0_linear_2735_27449)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2735_27449",
    x1: 3.82289,
    y1: -1.7748,
    x2: 3.82288,
    y2: 30.2082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8092e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38499b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonEnabled);
export default __webpack_public_path__ + "static/media/moon-enabled.b2ce8029b9752bf41334a472602497a0.svg";
export { ForwardRef as ReactComponent };